import { Card, Grid } from '@material-ui/core';
import React from 'react';
import { Divider, Typography } from '@material-ui/core'
import { themeColors } from 'app/components/MatxTheme/themeColors'
import { MatxLayoutSettings } from 'app/components/MatxLayout/settings'
import { Button } from "app/components/LoonsLabComponents";
//import 'react-confirm-alert/src/react-confirm-alert.css';
import "./styles.css";

const ConfirmationDialogUI = ({ onClose, onConfirm, title = 'Are you sure?', subTitle = '', confirmButtonText = "Yes", unConfirmButtonText = "No" }) => {

    let activeTheme = MatxLayoutSettings.activeTheme
    return (
        <div className="react-confirm-alert-overlay" style={{ backgroundColor: 'rgb(0 0 0 / 36%)', zIndex: 1400 }}>
            <Card elevation={6} className="px-4 pb-1 pt-4"
                style={{
                    padding: 4,
                    borderTopStyle: 'solid',
                    borderTopColor: themeColors[activeTheme].palette.primary.main,
                    borderTopWidth: '8px'
                    //boxShadow: `0px 4px 20px ${themeColors[activeTheme].palette.primary.main}`, // Custom shadow color
                }}
            >
                <div className="custom-ui">
                    <Grid container spacing={1}>
                        <Grid item>
                            <img src="/assets/images/Caution.gif" alt="Loading..." className="Caution-gif" style={{ width: 100 }} />
                        </Grid>
                        <Grid item >
                            <Typography variant="h5" style={{ color: themeColors[activeTheme].palette.subTitleTextColor }} className="font-semibold">
                                {title}</Typography>
                            <p>{subTitle}</p>
                        </Grid>
                    </Grid>
                    <Divider />

                    <div className='w-full flex justify-end'>
                        <Button
                            onClick={onClose}
                            className="button-danger"
                            color="primary"
                        //size="small"
                        >
                            {unConfirmButtonText}
                        </Button>
                        <Button
                            className="button-success"
                            onClick={() => {
                                onConfirm();
                                onClose();
                            }}
                        >
                            {confirmButtonText}
                        </Button>
                    </div>


                </div>
            </Card>
        </div>
    );
};

export default ConfirmationDialogUI;